import React, { useEffect, useState } from 'react'
import { GB, DE, FR, ES, PT } from 'country-flag-icons/react/3x2'
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import Tooltip from '@mui/material/Tooltip';
const FlagSelector: React.FC = () => {
    const [selectedLanguage, setSelectedLanguage] = useState<string | null>(sessionStorage.getItem('language'));
    const [hoveredLanguage, setHoveredLanguage] = useState<string | null>(null);
    const changeLanguage = (lng: string): void => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                UserId: sessionStorage.getItem('userId'),
                UserGuid: sessionStorage.getItem('userGuid'),
                FilterGroupId: sessionStorage.getItem('filterGroupId'),
                FlowUnits: sessionStorage.getItem('flowUnits'),
                UtcOffset: sessionStorage.getItem('utcOffset'),
                InactiveTimeframe: sessionStorage.getItem('inactiveTimeframe'),
                GraphTotaliser: sessionStorage.getItem('graphTotaliser'),
                Language: lng,
                CanConfig: sessionStorage.getItem('canConfig')
            })
        };

        CallGetAPI(CreateUrl('/api/aquaguard/SetUserPreferences'), requestOptions)
            .then(data => {
                console.log(data)


            })
            .catch(function (error) {

                console.log(error);
            });

        console.log(`Language changed to: ${lng}`);
        sessionStorage.setItem('language', lng);
        setSelectedLanguage(lng);
        window.location.reload();
    };
    useEffect(() => {
        const storedLanguage = sessionStorage.getItem('language');
        console.log(storedLanguage)
        if (storedLanguage) {
            setSelectedLanguage(storedLanguage);
        }
    }, []);
    const getFlagStyles = (lng: string) => {
        const isSelected = selectedLanguage === lng;
        const isHovered = hoveredLanguage === lng;
        return {
            fontSize: '32px',
            cursor: 'pointer',
            margin: '5px',
            transition: 'transform 0.3s ease',
            transform: isSelected || isHovered ? 'scale(1.2)' : 'scale(1)',
            border: isSelected ? '2px solid #EED202' : 'none',
            padding: isSelected ? '2px' : '0',
        };
    };
    return (
        <div style={{ display: "flex", width: "180px", margin: "auto 30px" }}>
            <GB
                style={getFlagStyles('en-GB')}
                onClick={(): void => changeLanguage('en-GB')}
                onMouseEnter={(): void => setHoveredLanguage('en-GB')}
                onMouseLeave={(): void => setHoveredLanguage(null)}
            />
            <ES
                style={getFlagStyles('es-ES')}
                onClick={(): void => changeLanguage('es-ES')}
                onMouseEnter={(): void => setHoveredLanguage('es-ES')}
                onMouseLeave={(): void => setHoveredLanguage(null)}
            />
            <FR
                style={getFlagStyles('fr-FR')}
                onClick={(): void => changeLanguage('fr-FR')}
                onMouseEnter={(): void => setHoveredLanguage('fr-FR')}
                onMouseLeave={(): void => setHoveredLanguage(null)}
            />
            <DE
                style={getFlagStyles('de-DE')}
                onClick={(): void => changeLanguage('de-DE')}
                onMouseEnter={(): void => setHoveredLanguage('de-DE')}
                onMouseLeave={(): void => setHoveredLanguage(null)}
            />
            <PT
                style={getFlagStyles('pt-PT')}
                onClick={(): void => changeLanguage('pt-PT')}
                onMouseEnter={(): void => setHoveredLanguage('pt-PT')}
                onMouseLeave={(): void => setHoveredLanguage(null)}
            />
        </div>
    );
}
export default FlagSelector